import React from 'react';
import logo from './../../img/logo.svg';
import './header.scss';
import { Container } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import { blue } from '@material-ui/core/colors';
class Header extends React.Component {
  state = {
    anchorEl: null,
  };

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;

    return (
      <header className="App_header">
        <Container maxWidth="md">
          <a href="/">
            <img src={logo} className="App_logo" alt="iTrust logo" />
          </a>
          <div className="App_main_menu_desktop">
            <ul>
              <li>
                <a href="#Features">Features</a>
              </li>

              <li>
                <a href="#Partners">Partners</a>
              </li>
              <li>
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://itrustinternational.medium.com/"
                >
                  Blog
                </a>
              </li>
              <li>
                <a href="https://app.itrust.finance/">iTrust App</a>
              </li>
            </ul>
          </div>
          <Button
            aria-owns={anchorEl ? 'mobile-menu' : undefined}
            aria-haspopup="true"
            onClick={this.handleClick}
          >
            <div className="App_menubar b1"></div>
            <div className="App_menubar b2"></div>
            <div className="App_menubar b3"></div>
          </Button>
          <Menu
            //add inline styles override to popover
            PaperProps={{
              style: {
                width: '100%',
                marginTop: '10px',
                left: '32px',
                right: '32px',
                backgroundColor: blue,
              },
            }}
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <ul>
              <li>
                <a onClick={this.handleClose} href="#Features">
                  Features
                </a>
              </li>

              <li>
                <a onClick={this.handleClose} href="#Partners">
                  Partners
                </a>
              </li>
              <li>
                <a
                  rel="noreferrer"
                  target="_blank"
                  onClick={this.handleClose}
                  href="https://itrustinternational.medium.com/"
                >
                  Blog
                </a>
              </li>
              <li>
                <a
                  rel="noreferrer"
                  onClick={this.handleClose}
                  href="https://app.itrust.finance/"
                >
                  iTrust App
                </a>
              </li>
            </ul>
          </Menu>
        </Container>
      </header>
    );
  }
}

export default Header;
